

















































































































































































































































































































































import Vue from 'vue'
import { downloadFile, isDisplayShow, limitNumber } from '@/utils'
import { exportProductCraftGET, exportProcessTemplateGET, importProductpProcess } from '@/api/api'
import DocModal from './DocModal.vue'
import RemarkModal from './RemarkModal.vue'
import * as _ from 'lodash'
import {
  ProductServiceProxy,
  ProductionCraftServiceProxy,
  ProductionCraftAddDTO,
  ProductionCraftProcessServiceProxy,
  SaveOrUpdateCraftProcessDTO,
  ProductCraftProcessDTO,
  ProductionCraftProcessDTO,
  ProductionCraftProcessUpdateDTO,
  ProductionFixedCraftProcessUpdateDTO,
  ProductTypeServiceProxy,
  CopyCraftDTO
} from '@/service-proxies/app-v2/product.service-proxies'
import { ProcessServiceProxy, ProcessSearchDTO } from '@/service-proxies/app-v2/workStation.service-proxies'
import { TenantBizFieldServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'

const processServiceProxy = new ProcessServiceProxy()
const productServiceProxy = new ProductServiceProxy()
const productionCraftServiceProxy = new ProductionCraftServiceProxy()
const productionCraftProcessServiceProxy = new ProductionCraftProcessServiceProxy()
const tenantBizFieldServiceProxy = new TenantBizFieldServiceProxy()
const ptsp = new ProductTypeServiceProxy()
export default Vue.extend({
  name: 'TabPanel',
  components: {
    DocModal,
    RemarkModal
  },
  props: {
    productId: {
      type: String,
      default: ''
    },
    typeId: {
      type: String,
      default: ''
    },
    isRefresh: { // 是否重置工艺版本的选中状态，默认重置
      type: Boolean,
      default: true
    }
  },
  data() {

    return {
      tableData: [], // 产品工序列表
      cacheData: [], // 备份表格数据
      loading: false,
      selectedRowKeys: [],
      craftList: [], // 工艺版本列表
      selectedCraft: '', // 当前选中的工艺版本id
      selectedCraftItem: {},  // 当前选中的工艺版本
      processList: [], // 工序列表
      dateTime: { d: 0, h: 0, m: 0, s: 0 }, // 天时分秒
      dateTimePrepare: { d: 0, h: 0,m: 0, s: 0},
      dateTimeDisassembly: { d: 0, h: 0,m: 0, s: 0},
      docModalVisible: false,
      programList: [], // 程序列表
      showColumns: [], // 展示的表格字段
      columns: [], // 所有表格字段
      tableScrollWidth: 1700,
      extraColumns: [], // 额外字段
      timeColumns: ['prepareTime', 'disassemblyTime', 'transportTime'], // 新增的3个工时字段
      allSaveFlag: false, // 保存按钮的可点击状态
      limitNumber,
      importProcessVisible: false,
      downloadFn: null,
      importFn: importProductpProcess,
      copyModalVisible: false,
      typeList: [],// 产品类型列表
      productListInfo: [],// 产品列表信息
      productList: [],// 产品列表
      form: {
        productType: '',
        productId: '',
        productName: '123'
      },
      copyLoading: false, // 复制工艺版本至其他产品的加载状态
      remarkModalVisible: false,
      fetching: false, // 筛选工序编号/名称的状态
      lastFetchId: 0
    }
  },
  computed: {
    searchProcessList2 () {
      return  _.debounce(this.searchProcessList, 800)
    }
  },
  watch: {
    productId(val) {
      if (val) {
        this.selectedRowKeys = []
        if (this.isRefresh) {
          this.selectedCraft = ''
          this.selectedCraftItem = {}
        }
        this.getCraftList()
      } else {
        this.craftList = []
        this.tableData = []
      }
    },
    typeId: {
      handler(val) {
        if (this.isRefresh) {
          this.selectedCraft = ''
          this.selectedCraftItem = {}
        }
        if (val) {
          this.getTableColumn()
          this.downloadFn = () => exportProcessTemplateGET(val)
        }
      },
      immediate: true
    },
    selectedCraftItem: {
      handler(val) {
        if (JSON.stringify(val) !== '{}') {
          if (val.editionStatus === 2) {
            if (this.showColumns.findIndex(item => item.key === 'action') > -1) {
              this.showColumns.splice(0, 1)
            }
            this.tableScrollWidth = (this.showColumns.length - 1) * 176
          } else if (val.editionStatus === 1) {
            if (this.showColumns.findIndex(item => item.key === 'action') < 0) {
              this.showColumns = [{
                title: this.$t('page_tenant_operation'),
                key: 'action',
                fixed: 'left',
                width: 70,
                scopedSlots: { customRender: 'action' }
              }, ...this.showColumns]
            }
            this.tableScrollWidth = (this.showColumns.length - 1) * 170
          }

          this.getResourceFileList()
        } else {
          this.programList = []
        }
      },
      deep: true
    },
    copyModalVisible(val) {
      if (val) {
        this.form.productType = this.typeId
        this.getProductTypeList()
        this.handleTypeChange(this.typeId)
      }
    },
    'form.productId': {
      handler(val) {
        if (val) {
          this.form.productName = this.productList.find(item => item.value === val).name
        }
      },
      deep: true
    }
  },
  created() {
    this.getCraftList()
    this.getProcessList()
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    // 获取指定业务的字段列表
    async getTableColumn() {
      this.columns = []
      this.columns = await tenantBizFieldServiceProxy.getTenantBizField('craft_process', this.typeId)
      this.handleColumns()
    },
    handleColumns() {
      this.showColumns = []
      this.timeColumns = []
      if (!this.columns || !this.columns.length) {
        return
      }
      // 字段排序
      this.columns.sort((a, b) => {
        return a.sort - b.sort
      })
      // 字段显隐
      let columns = []
      this.columns.map(item => {
        if (isDisplayShow(item.isDisplay, 3)) {
          /*if(item.code === "prepareTime")
          item.title = this.$t('page_product_prepareTime_time')
          if(item.code === "disassemblyTime")
          item.title = this.$t('page_product_disassemblyTime_time')*/
          // let scopedSlots = isDisplayShow(item.isDisplay, 1) ? { customRender: item.code } : null
          let scopedSlots = { customRender: item.code }
          // 自定义字段：产品类型
          switch (item.code) {
            case 'sort':
            case 'processSequence':
              columns.push({
                title: item.title,
                dataIndex: item.code,
                ellipsis: true,
                scopedSlots,
                key: item.code,
                width: 140
              })
              break
            case 'code':
            case 'name':
            case 'programName':
              // case 'prepareTime':
              // case 'disassemblyTime':
              // case 'transportTime':
              columns.push({
                title: item.title,
                dataIndex: item.code,
                ellipsis: true,
                scopedSlots,
                key: item.code,
                width: 176
              })
              break
            case 'standardTime':
              columns.push({
                title: item.title,
                dataIndex: item.code,
                ellipsis: true,
                scopedSlots,
                key: item.code,
                width: 220
              })
              break
            default:
              this.extraColumns.push(item.code)
              if (item.code.indexOf('Time') > -1) {
                this.timeColumns.push(item.code)
              }
              columns.push({
                title: item.title,
                key: item.code,
                dataIndex: item.code,
                scopedSlots,
                ellipsis: true,
                width: 220
              })
          }
        }
      })
      // 已定版的工序列表不允许删除
      /* if (this.selectedCraftItem.status === 2) {
         this.showColumns = [{
           title: this.$t('page_tenant_operation'),
           key: 'action',
           fixed: 'left',
           width: 140,
           scopedSlots: { customRender: 'action' }
         }, ...columns]
       }*/

      this.showColumns = [{
        title: this.$t('page_tenant_operation'),
        key: 'action',
        fixed: 'left',
        width: 140,
        scopedSlots: { customRender: 'action' }
      }, ...columns]

      // 最后一列不设宽度
      delete this.showColumns[this.showColumns.length - 1].width
      let num = this.showColumns.length
      this.tableScrollWidth = num * 170
    },
    // 按产品查询工艺版本列表
    getCraftList(last: string) {
      this.craftList = []
      // this.selectedCraft = ''
      // this.selectedCraftItem = {}
      if (!this.productId) {
        return
      }
      productionCraftServiceProxy.getProductionCraftByProduct(this.productId).then((res: any) => {
        if (res) {
          this.craftList = res
          this.$emit('initRefreshStatus') // 重置工艺版本的选中状态
          // 导入工序后选中最新的工艺版本
          if (last) {
            this.selectedCraft = res.length ? res[res.length - 1].id : ''
            this.selectedCraftItem = res.length ? res[res.length - 1] : {}
          } else {
            if (!this.selectedCraft) {
              this.selectedCraft = res.length ? res[0].id : ''
              this.selectedCraftItem = res.length ? res[0] : {}
            } else {
              // 若删除当前选中项则选中第一项；若只剩一项，删除后无选中项；否则仍然保持当前选中项
              this.selectedCraftItem = !res.length ? {} : (res.find(item => item.id === this.selectedCraft) ? res.find(item => item.id === this.selectedCraft) : res[0])
              if (JSON.stringify(this.selectedCraftItem) === '{}') {
                this.selectedCraft = ''
              } else {
                if (!res.find(item => item.id === this.selectedCraft)) {
                  this.selectedCraft = res[0].id
                }
              }
            }
          }
          this.getTableData()
          this.getResourceFileList()
        } else {
          this.selectedCraft = ''
          this.selectedCraftItem = {}
        }
      })
    },
    // 按照工艺版本查询产品工序列表---表格数据
    getTableData() {
      this.tableData = []
      this.cacheData = []
      this.selectedRowKeys = []
      if (!this.selectedCraft) {
        return
      }
      this.loading = true
      productionCraftServiceProxy.getProcessForProductionCraft(this.selectedCraft).then((res: any) => {
        this.tableData = res
        // this.cacheData = this.tableData.map(item => ({ ...item }))
        this.handleTableData()
        this.loading = false
      })
    },
    handleTableData() {
      // 编辑状态的数据转化
      if (this.tableData.length) {
        this.tableData.forEach(item => {
          item.editable = true
          item.name = { key: item.name } // 工序名称转对象
          item.dateTime = this.secondsToDate(item.standardTime)
          item.dateTimePrepare = this.secondsToDate(item.prepareTime)
          item.dateTimeDisassembly = this.secondsToDate(item.disassemblyTime)
          // 将工时的单位转换成小时
          // this.timeColumns.forEach(ite => {
          //   item[ite] = item[ite] ? this.secondsToHours(item[ite], 'minute') : 0
          // })
            this.timeColumns.forEach(ite => {
              if(ite === "transportTime")
              item[ite] = item[ite] ? this.secondsToHours(item[ite], 'minute') : 0
          })
        })
        this.cacheData = this.tableData.map(item => ({ ...item }))
      }
    },
    // 按工艺版本查询文件列表，用于程序名称选择
    getResourceFileList() {
      this.programList = []
      if (!this.selectedCraft || !this.selectedCraftItem.resourceId) {
        return
      }
      productionCraftServiceProxy.getResourceFileList(this.selectedCraftItem.resourceId).then((res: any) => {
        // console.log('程序列表：', res)
        this.programList = res
      })
    },
    // 工序列表,用于工序编号下拉选择
    async getProcessList(keywords?: string) {
      try {
        let keyWords = keywords ? keywords : ''
        const filterStatusList = {statusList: [1]} as any
        const { records } = await processServiceProxy.getPageProcess(1, filterStatusList, keyWords, 999)
        this.processList = records
        return records
      } catch (e) {
        return []
      }
    },
    async searchProcessList(keywords?: string) {
      this.lastFetchId += 1;
      const fetchId = this.lastFetchId;
      try {
        this.processList = []
        this.fetching = true
        let keyWords = keywords ? keywords : ''
        const filterStatusList = {statusList: [1]} as any
        const { records } = await processServiceProxy.getPageProcess(1, filterStatusList, keyWords, 999)
        if (fetchId !== this.lastFetchId) {
          this.fetching = false
          return;
        }
        this.processList = _.cloneDeep(records)
      } catch (e) {
      }
      this.fetching = false
    },
    // 选中工艺版本
    selectCraft(craftId: any) {
      // this.selectedCraft = craft.id
      this.selectedCraft = craftId
      this.selectedCraftItem = this.craftList.find(item => item.id === craftId)
      this.getTableData()
    },
    // 删除工艺版本
    deleteCraft(id: string) {
      this.$confirm({
        title: this.$t('page_product_prompt'),
        content: this.$t('page_product_comfirm_delete'),
        okText: this.$t('ok'),
        cancelText: this.$t('cancel'),
        onOk: () => {
          return new Promise((resolve, reject) => {
            productionCraftServiceProxy.deleteProductionCraft(id).then((res: any) => {
              if (res) {
                this.getCraftList()
                resolve()
                this.$message.success(this.$t('page_resource_pool_success'))
              }
            })
          })
        }
      })
    },
    // 新建工艺版本
    createCraft() {
      productionCraftServiceProxy.createProductionCraft(new ProductionCraftAddDTO({ productId: this.productId })).then((res: any) => {
        if (res) {
          this.selectedCraft = res
          this.getCraftList()
          this.$message.success(this.$t('page_resource_pool_success'))
        }
      })
    },
    // 定版工艺版本
    fixedEdition() {
      if (!this.tableData.length) {
        this.$message.info(this.$t('page_product_please_add_process'))
        return
      }
      let flag = this.validate()
      if (!flag) {
        // this.$message.info('存在尚未保存的工序数据，请先保存')
        this.$confirm({
          title: this.$t('page_business_data_fixed_tip_title'),
          content: this.$t('page_business_data_fixed_tip'),
          okText: this.$t('page_business_data_save_and_fixed'),
          cancelText: this.$t('cancel'),
          onOk: () => {
            return new Promise(async (resolve, reject) => {
              const saveFlag = await this.saveAll()
              if (saveFlag) {
                productionCraftServiceProxy.fixedEditionForProductionCraft(this.selectedCraft).then((res: any) => {
                  this.getCraftList()
                  resolve()
                })
              } else {
                reject()
              }
            })
          }
        })
        return
      }
      productionCraftServiceProxy.fixedEditionForProductionCraft(this.selectedCraft).then((res: any) => {
        this.getCraftList()
      })
    },
    // 定版工艺版本前判断是否更新工序；若更新了工序，则需要先保存再定版
    validate() {
      let flag = true
      if (!this.cacheData) {
        flag = false
      } else if (this.cacheData.length !== this.tableData.length) {
        flag = false
      } else {
        this.cacheData.forEach(item => {
          if (this.tableData.findIndex(ite => ite.id === item.id) < 0) { // 删除了项
            flag = false
            return
          }
          this.tableData.forEach(ite => {
            if (this.cacheData.findIndex(item1 => ite.id === item1.id) < 0) { // 新增了项
              flag = false
              return
            }
            if (item.id === ite.id) {
              for (let key in item) {
                if (item[key] !== ite[key]) {
                  flag = false
                  return
                }
              }
            }

          })
        })
      }
      return flag
    },
    // 表格勾选事件
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      // console.log('selectedRowKeys:', selectedRowKeys)
    },
    // 新建工序
    addProcess() {
      const { tableData } = this
      // 先创建工艺版本
      if (!this.selectedCraft) {
        this.$message.info(this.$t('page_product_please_create_version'))
        return
      }
      // 当前有正在新建中的一条数据
      /*if (tableData.length && tableData[tableData.length - 1].id === '0') {
        return
      }*/
      // 先保存正在编辑的数据
      /*if (tableData.find(item => item.editable)) {
        this.$message.info(this.$t('page_product_please_save_edition'))
        return
      }*/
      // 按顺序生成工序顺序
      tableData.sort((a, b) => a.sort - b.sort)
      let sort = tableData.length ? tableData[tableData.length - 1].sort + 1 : 1
      let key = tableData.length ? String(-tableData.length) : '0'
      const newData = {
        key: key,
        sort: sort, // 工序顺序
        processSequence: sort, // 工序号
        code: '', // 工序编号
        name: '',
        programName: '', // 程序名称
        standardTime: 0, // 标准工时（秒）
        craftId: this.selectedCraft, // 工艺ID
        processId: null, // 所属生产工序
        editable: true,
        id: key,
        prepareTime: 0,
        disassemblyTime: 0,
        transportTime: 0,
        dateTime: {},
        dateTimePrepare: {},
        dateTimeDisassembly: {}
      }
      this.extraColumns.forEach(item => {
        newData[item] = ''
      })
      this.timeColumns.forEach(item => {
        // newData[item] = 0
        if(item === "transportTime") {
          newData[item] = 0
        }
      })
      newData.dateTime = this.secondsToDate(0)
      newData.dateTimePrepare = this.secondsToDate(0)
      newData.dateTimeDisassembly = this.secondsToDate(0)
      this.tableData = [...tableData, newData]
      console.log(1111,this.tableData)
      this.getProcessList()
    },
    handleEdit(record: any) {
      // console.log('编辑:', record)
      const newData = [...this.tableData]
      const target = newData.filter(item => record.id === item.id)[0]
      if (target) {
        target.editable = true
        target.name = { key: target.name } // 工序名称转对象
        target.dateTime = this.secondsToDate(target.standardTime)
        target.dateTimePrepare = this.secondsToDate(target.prepareTime)
        target.dateTimeDisassembly = this.secondsToDate(target.disassemblyTime)
        // 将工时的单位转换成小时
        // this.timeColumns.forEach(item => {
        //   target[item] = this.secondsToHours(target[item], 'minute')
        // })
        this.timeColumns.forEach(item => {
          if(item === "transportTime")
          target[item] = this.secondsToHours(target[item], 'minute')
        })
        this.tableData = newData
      }
    },
    // 删除工序
    async handleDelete(record?: any) {
      try {
        let processIds = []
        if (record) { // 单个
          processIds.push(record.id)
        } else { // 批量
          processIds = _.cloneDeep(this.selectedRowKeys)
        }
        this.$confirm({
          title: this.$t('page_product_confirm_delete_process'),
          okText: this.$t('ok'),
          cancelText: this.$t('cancel'),
          onOk: () => {
            return new Promise((resolve, reject) => {
              // 未保存，直接删除，不走接口
              // const tempProcessIds = processIds.filter(id => Number(id) <= 0)
              processIds.map(id => {
                let index = this.tableData.findIndex(item => item.id === id)
                this.tableData.splice(index, 1)
                let index2 = this.selectedRowKeys.findIndex(key => key === id)
                this.selectedRowKeys.splice(index2, 1)
              })
              resolve()
              // 已保存，走接口删除
              /*processIds = processIds.filter(id => Number(id) > 0)
              productionCraftProcessServiceProxy.deleteProductionCraftProcess(processIds).then(res => {
                this.$message.success(this.$t('page_resource_pool_success'))
                // this.getTableData()
                resolve()
              })*/
            })
          }
        })
      } catch (e) {
        console.error(e)
      }
    },
    // 复制工艺版本到当前产品
    handleCopy() {
      if (!this.selectedCraft) {
        return
      }
      productionCraftServiceProxy.copy(this.selectedCraft).then((res: any) => {
        if (res) {
          this.selectedCraft = res
          this.getCraftList()
        }
      })
    },
    // 复制类型选择
    handleMenuClick({ key }) {
      if (key === '1') {
        // 当前产品
        this.handleCopy()
      } else {
        // 其他产品
        this.copyModalVisible = true
      }
    },
    // 复制到其他产品类型下
    async copyToOther() {
      if (!this.form.productType) {
        this.$message.error(this.$t('page_business_copy_to_product_type'))
        return
      }
      if (!this.form.productId) {
        this.$message.error(this.$t('page_business_copy_to_product_name'))
        return
      }
      this.copyLoading = true
      let params = new CopyCraftDTO({
        craftId: this.selectedCraft,
        productId: this.form.productId
      })
      let res = await productionCraftServiceProxy.copyCraftToOtherProduct(params)
      this.copyLoading = false
      if (!res) {
        return
      }
      this.selectedCraft = res // 设置选中的工艺版本
      this.copyModalVisible = false // 关闭复制选择框
      // console.log('复制到其他产品类型下：', res)
      // 跳转到新建的工艺版本下（涉及切换产品类型与产品）
      let data = {}
      let index = this.productList.findIndex(item => item.value === this.form.productId)
      let total = this.productList.length
      if (this.typeId !== this.form.productType) { // 切换了产品类型与产品
        Object.assign(data, { productTypeId: this.form.productType, productId: this.form.productId, index, total })
        this.$emit('change', data)
      } else {
        if (this.form.productId !== this.productId) { // 切换了产品
          Object.assign(data, { productId: this.form.productId, index, total })
          this.$emit('change', data)
        }
      }
    },
    async getProductTypeList() {
      let res = await ptsp.getProductTypeList()
      let temp = []
      if (res && res.length) {
        // 过滤未启用的产品类型
        res = res.filter(item => item.status === 2)
        temp = res.map(item => ({ label: item.name, value: item.id }))
      }
      this.typeList = temp
    },
    // 选择产品类型，加载产品列表
    async handleTypeChange(val: string) {
      this.form.productId = ''
      this.form.productName = ''
      let res = await productServiceProxy.getProductList(val)
      let temp = []
      if (res && res.length) {
        temp = res.map(item => ({ label: item.code, value: item.id, name: item.name }))
      }
      this.productList = temp
      if (temp.length) {
        this.form.productId = temp[0].value
        this.form.productName = temp[0].name
      }
    },
    closeCopyModal(flag: boolean) {
      this.copyModalVisible = false
    },
    // 导出产品工艺流程
    handleExport() {
      if (!this.selectedCraft) {
        return
      }
      exportProductCraftGET(this.selectedCraft).then((res: any) => {
        downloadFile(res, 'Product craft.xlsx')
      })
    },
    handleInputChange(value: string | number, key: string, column: string, item: string) {
      // console.log('输入框：', value, key, column)
      const newData = [...this.tableData]
      const target = newData.filter(item => key === item.id)[0]
      if (target) {
        if (column === 'standardTime') {
          target.dateTime[item] = value
          target.standardTime = this.dateToSeconds(target.dateTime)
        } else if(column === 'prepareTime') {
          target.dateTimePrepare[item] = value
          target.prepareTime = this.dateToSeconds(target.dateTimePrepare)
        } else if(column === 'disassemblyTime') {
          target.dateTimeDisassembly[item] = value
          target.disassemblyTime = this.dateToSeconds(target.dateTimeDisassembly)
        } else {
          // console.log('input:',value)
          target[column] = value
        }
        this.tableData = newData
      }
    },
    // 选择工序编号，自动带出工序名称
    handleSelectChange(value: any, key: string, column: string) {
      // console.log('选择框：', value, key, column)
      const newData = [...this.tableData]
      const target = newData.filter(item => key === item.id)[0]
      let process = null
      if (target) {
        switch (column) {
          case 'code':
            // console.log(value)
            process = this.processList.find(item => item.code === value)
            target[column] = value // 工序编号
            target.name = { key: process.name }  // 工序名称
            target.processId = process.id
            break
          case 'name':
            // console.log(value)
            process = this.processList.find(item => item.code === value.key)
            target.code = value.key // 工序编号
            target[column] = { key: value.label } // 工序名称
            target.processId = process.id
            break
          case 'programName':
            if (!value) {
              target[column] = ''
              target.fileId = ''
            } else {
              // 程序名称传label字段
              this.programList.map(program => {
                if (value && program.fileId === value) {
                  target[column] = program.fileName
                  target.fileId = value
                }
              })
            }
            break
        }
        this.tableData = newData
      }
    },
    // 取消编辑
    cancel(key: string) {
      const newData = [...this.tableData]
      const target = newData.filter(item => key === item.id)[0]
      if (target) {
        if (Number(key) <= 0) { // 取消新增
          newData.splice(newData.length - 1, 1)
        } else { // 取消编辑
          Object.assign(target, this.cacheData.filter(item => key === item.id)[0])
          // delete target.editable
        }
        this.tableData = newData
      }
    },
    // 点击保存按钮可同时保存多条
    async saveAll() {
      if (!this.tableData.length) {
        return false
      }
      // await this.getProcessList()
      let process, flag = true
      console.log('保存所有工序：', this.tableData)
      this.tableData.map(record => {
        process = this.processList.find(item => item.code === record.code)
        // record.processId = process ? process.id : ''
        // 工序编号必填
        if (!record.processId) {
          this.$message.error(this.$t('page_product_please_select_process_number'))
          flag = false
          return false
        }
      })

      // 校验不通过 || 工序顺序重复
      if (!flag || this.isRepeat(this.tableData, 'sort')) {
        return false
      }

      const tempData = _.cloneDeep(this.tableData)
      let productCraftProcessDTOList = tempData.map(record => {
        let { programName, sort, standardTime, fileId, processId, processSequence } = record
        let id = '', tempItem
        // this.timeColumns.forEach(item => {
        //   record[item] = record[item] ? this.hourToSeconds(record[item]) : 0
        // })
        this.timeColumns.forEach(item => {
          if(item === "transportTime")
          record[item] = record[item] ? this.hourToSeconds(record[item]) : 0
        })
        if (Number(record.key) > 0) { // 编辑
          id = record.key
        }
        tempItem = {
          programName,
          fileId,
          standardTime,
          processId,
          sort,
          id,
          processSequence
        }
        this.extraColumns.forEach(item => {
          tempItem[item] = record[item]
        })
        return new ProductCraftProcessDTO(tempItem)
      })

      let params = new SaveOrUpdateCraftProcessDTO({
        craftId: this.selectedCraft,
        productCraftProcessDTOList
      })
      try {
        await productionCraftProcessServiceProxy.saveOrUpdateCraftProcess(params)
        this.$message.success(this.$t('page_resource_pool_success'))
        this.getProcessList()
        this.getTableData()
        return true
      } catch (e) {
        return false
      }
    },
    // 保存工序
    save(key: string) {
      const { code, sort } = this.tableData.find(item => item.id === key)
      const process = this.processList.find(item => item.code === code)
      const processId = process ? process.id : ''
      // 工序编号必填
      if (!processId) {
        this.$message.error(this.$t('page_product_please_select_process_number'))
        return
      }
      // 工序顺序不能重复
      let filterData = this.tableData.filter(item => item.id !== key)
      let flag = filterData.find(item => item.sort === sort)
      if (flag) {
        this.$message.error(this.$t('page_product_diff_process_sort'))
        return
      }

      if (Number(key) <= 0) {
        this.addSave(key, processId)
      } else {
        this.editSave(key, processId)
      }
    },
    // 暂存工艺版本指定的工序配置
    async addSave(key: string, processId: string) {
      const editItem = this.tableData.find(item => item.id === key)
      const { programName, sort, standardTime, fileId, processSequence } = editItem
      // this.timeColumns.forEach(item => {
      //   editItem[item] = this.hourToSeconds(editItem[item])
      // })
      this.timeColumns.forEach(item => {
        if(item === "transportTime")
        editItem[item] = this.hourToSeconds(editItem[item])
      })
      try {
        let params = {
          craftId: this.selectedCraft,
          processId, // 所属生产工序,根据工序编号得出
          programName: programName ? programName : '',
          sort,
          processSequence,
          standardTime,
          fileId: fileId ? fileId : ''
        } as ProductionCraftProcessDTO
        this.extraColumns.forEach(item => {
          params[item] = editItem[item]
        })
        await productionCraftProcessServiceProxy.storageProcessForCraft(params)
        // this.getTableData()
        this.$message.success(this.$t('page_resource_pool_success'))
      } catch (e) {
        console.error(e)
      }
    },
    // 更新
    async editSave(key: string, processId: string) {
      const editItem = this.tableData.find(item => item.id === key)
      const { programName, sort, standardTime, fileId, processSequence } = editItem
      // this.timeColumns.forEach(item => {
      //   editItem[item] = this.hourToSeconds(editItem[item])
      // })
      this.timeColumns.forEach(item => {
        if(item === "transportTime")
        editItem[item] = this.hourToSeconds(editItem[item])
      })
      try {
        // 版本状态（1-暂存，2-定稿）
        if (this.selectedCraftItem.editionStatus === 2) { // 更新已定版工艺版本的指定工序信息
          let params = {
            id: key,
            programName: programName ? programName : '',
            fileId: fileId ? fileId : '',
            standardTime
          } as any
          this.extraColumns.forEach(item => {
            params[item] = editItem[item]
          })
          await productionCraftProcessServiceProxy.updateProcessForFixedCraft(params)
        } else { // 更新未定版工艺版本的指定工序
          let params = {
            id: key,
            programName: programName ? programName : '',
            fileId: fileId ? fileId : '',
            standardTime,
            craftId: this.selectedCraft,
            processId,
            sort,
            processSequence
          } as ProductionCraftProcessUpdateDTO
          this.extraColumns.forEach(item => {
            params[item] = editItem[item]
          })
          await productionCraftProcessServiceProxy.updateProcessForCraft(params)
        }
        // this.getTableData()
        this.$message.success(this.$t('page_resource_pool_success'))
      } catch (e) {
        console.error(e)
      }
    },
    // 秒数转换成天时分秒，用于编辑
    secondsToDate(val: number) {
      let d = Math.floor(val / 86400)
      let h = Math.floor(val % 86400 / 3600)
      let m = Math.floor(val % 86400 % 3600 / 60)
      let s = val % 86400 % 3600 % 60
      this.dateTime = { d, h, m, s }
      this.dateTimePrepare = { d, h, m, s }
      this.dateTimeDisassembly = { d, h, m, s }
      return { d, h, m, s }
    },
    // 天时分秒转换成秒，用于保存
    dateToSeconds(time: any) {
      // const time = this.dateTime
      const seconds = time.d * 86400 + time.h * 3600 + time.m * 60 + time.s
      return seconds
    },
    // 秒转换成时分秒,用于显示;或传入单位，将秒转换成指定单位的时间
    secondsToHours(val: number, unit: string) {
      let h = Math.floor(val / 3600)
      let m = Math.floor(val % 86400 % 3600 / 60)
      let s = val % 86400 % 3600 % 60

      if (unit === 'hour') {
        return (val / 3600)
      } else if (unit === 'minute') {
        return (val / 60)
      }
      return `${h > 9 ? h : '0' + h}:${m > 9 ? m : '0' + m}:${s > 9 ? s : '0' + s}`
    },
    // 分钟转成秒数,用于保存
    hourToSeconds(val: number) {
      return val * 60
    },
    // 工艺文档
    openDocModal() {
      this.docModalVisible = true
    },
    // 关闭工艺文档上传弹出框，重新加载程序列表
    closeDocModal(reload?: boolean) {
      this.docModalVisible = false
      this.getResourceFileList()
      // if (reload) {
      //   this.getResourceFileList()
      // }
    },
    isRepeat(arr, key) {
      let hash = {}
      for (let i in arr) {
        if (hash[arr[i][key]]) {
          return true
        }
        hash[arr[i][key]] = true
      }
      return false
    },
    // 输入工序顺序后
    onSortBlur(e: any, key: string, column: string) {
      const value = Number(e.target.value)
    // 说明有重复，>= 当前数字的自动加一
      this.tableData.forEach(res => {
        if (res.sort >= value && key !== res.id) {
          res.sort += 1
        }
      })
      this.tableData.sort((pre, next) => {
        return (pre.sort > next.sort) ? 1 : -1
      })
    },
    // 添加版本备注
    showRemarkModal() {
      this.remarkModalVisible = true
    },
    closeRemarkModal() {
      this.remarkModalVisible = false
    }
  }
})
